(() => {
  if (window.vmAutumnCountdownLoaded) return;
  window.vmAutumnCountdownLoaded = true;
  function tick() {
    document.querySelectorAll('[data-vm-countdown-root]').forEach(root => {
      const end = Date.parse(root.dataset.end);
      const total = Math.max(0, Math.floor((end - Date.now()) / 1000));
      if (!Number.isFinite(end) || total === 0) { root.hidden = true; return; }
      const values = {days: Math.floor(total / 86400), hours: Math.floor(total % 86400 / 3600), minutes: Math.floor(total % 3600 / 60), seconds: total % 60};
      Object.entries(values).forEach(([key, value]) => { root.querySelector('[data-vm-unit="' + key + '"]').textContent = String(value).padStart(2, '0'); });
      root.querySelector('[data-vm-clock]').hidden = false;
    });
  }
  tick();
  setInterval(() => { if (!document.hidden) tick(); }, 1000);
  document.addEventListener('visibilitychange', tick);
  document.addEventListener('shopify:section:load', tick);
})();
